module.exports = __webpack_public_path__ + "img/barCode.b063d6d5.gif";